<template>
    <v-container fluid id="credit" class="py-15">
        <v-container v-bind="binding">
            <v-row class="text-left">
                <v-col cols="12" md="10" offset-md="1">
                    <div class="mx-auto font-weight-light mt-10">
                        <p class="subtitle-1 font-weight-bold">{{$t("LP.credit.organizer")}}
                        </p>
                        <p class="text-body-1 text-pre-wrap" v-html="$t('LP.credit.organizer_caption')"></p>
                    </div>
                    <div class="mx-auto font-weight-light mt-5 mt-md-10">
                        <p class="subtitle-1 font-weight-bold mb-5">{{$t("LP.credit.project")}}</p>
                        <a :href="corporate_url" target="_blank">
                            <v-img :src="corporate_logo" max-width="300px">
                            </v-img>
                        </a>
                        <p class="text-caption text-sm-body-1 mt-7" v-html="$t('LP.credit.caption')">
                        </p>
                        <a class="body-1" href="https://naked.co.jp" target="_blank"
                            style="color:#fff;">https://naked.co.jp</a>
                    </div>
                </v-col>

            </v-row>
        </v-container>
    </v-container>
</template>

<style lang="scss" scoped>
    #credit {
        background: #00133E;
    }
</style>

<script>
export default {
    data: () => ({
        corporate_url: 'https://naked.co.jp/',
        corporate_logo: './Images/NAKED,INC._Logotype_w.svg',
    })
}
</script>